import AttributePills from "./Attributes";
export { AttributePills };
